import React from 'react';
import classNames from 'classnames';
import { SKELETON_VARIANTS } from './constants';


const Skeleton = ({ className = '', variant = SKELETON_VARIANTS.RECTANGULAR, ...props }) => {
  const classes = classNames(
    'bg-gray-700 animate-fade-pulse',
    {
      'rounded-md': variant === SKELETON_VARIANTS.RECTANGULAR,
      'rounded-full': variant === SKELETON_VARIANTS.CIRCULAR,
      'rounded h-4 w-full': variant === SKELETON_VARIANTS.TEXT,
    },
    className
  );

  return (
    <div
      className={classes}
      {...props}
    />
  );
};

export default Skeleton;
